<mat-form-field class="width-100" subscriptSizing="dynamic">
	<mat-label class="small-above-label">{{ labelName | translate }}</mat-label>

	<div class="input-wrapper">
		<input
			class="cost-of-work"
			matInput
			type="quantity"
			mask="separator.2"
			#inputHTMLField
			maxlength="13"
			[value]="formControl.value | mask: 'separator.2'"
			(keydown)="keyDownHandler()"
			[formControl]="formControl"
			(focus)="inputOnFocus.set(true)"
			(blur)="onBlurHandler()"
			(keydown.enter)="enterKeyDownHandler($event)"
		/>
		@if (inputHTMLField.value || inputOnFocus()) {
			<span class="input-postfix">NOK</span>
		}
	</div>

	<mat-error>
		@if (formControl.errors?.pattern) {
			<span>{{ 'incorrect_value' | translate }}</span>
		}
	</mat-error>
</mat-form-field>
